export default __webpack_public_path__ + "static/media/pic16.1bff2d40.jpg";